import React, { Component } from 'react';
import { Card, Tab, Nav, Row, Col, Form, Button } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import moment from 'moment';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from './DashboardLayout';
import { projectService, activityService, tasksService } from '../services';
import Loading from '../components/Loader';
import { TeamActivityList } from '../components/activity';
import {
  ProjectListDropdown,
  PercentageRangeListDropdown,
  DateRangePickerField,
  WorkSessionTypeDropdown,
} from '../components/common';
import {
  API_FAILURE_ERROR,
  DATE_RANGE_OPTIONS,
  STATUS_CHECK_DELAY,
} from '../constants';
import { fetchOnlineMembers } from '../actions/team';
import { getUserData } from '../helpers';

class TeamDateRangeActivity extends Component {
  userData = JSON.parse(localStorage.getItem('USER_DATA'));

  state = {
    isLoading: true,
    projectsList: [],
    tasksList: [],
    startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    activityList: [],
    isFetchingActivityData: false,
    isUpdatingProjectsList: false,
    isUpdatingTasksList: false,
  };

  pageHeading = {
    preTitle: 'Activity',
    title: 'Team Activity',
  };

  componentDidMount() {
    this.getProjectData();
    this.getTaskData({
      teamOwnerId: localStorage.getItem('teamOwnerId'),
    });
    const { startDate, endDate } = this.state;
    this.handleGenerateData({
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      fromDate: startDate,
      toDate: endDate,
      activity: 'all',
      project: 'all',
      task: 'all',
      workSessionType: 'all',
    });

    const { getOnlineMembers } = this.props;
    // Fetch online members list onMount
    getOnlineMembers();
    // Check for online members every 2 minutes
    this.statusTimer = setInterval(
      () => getOnlineMembers(),
      STATUS_CHECK_DELAY
    );
  }

  componentWillUnmount() {
    // Clear interval on un mount
    clearInterval(this.statusTimer);
  }

  handleDateSelect = (event, picker) => {
    this.setState((state) => ({
      ...state,
      startDate: moment(picker.startDate).format('YYYY-MM-DD'),
      endDate: moment(picker.endDate).format('YYYY-MM-DD'),
    }));
  };

  getProjectData = () => {
    this.setState((state) => ({
      ...state,
      isUpdatingProjectsList: true,
    }));

    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      summaryList: true,
      filter: JSON.stringify({
        projectStatus: 'active',
      }),
    };
    projectService
      .get_projects_data(params)
      .then((response) => {
        const {
          data: { projects },
        } = response;
        this.setState((state) => ({
          ...state,
          isLoading: false,
          projectsList: [...projects],
          isUpdatingProjectsList: false,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          isUpdatingProjectsList: false,
        }));
      });
  };

  getTaskData = (data) => {
    this.setState((state) => ({
      ...state,
      isUpdatingTasksList: true,
    }));
    tasksService
      .get_tasks_data(data)
      .then((result) => {
        const { tasks } = result.data;
        this.setState((state) => ({
          ...state,
          isLoading: false,
          tasksList: [...tasks],
          isUpdatingTasksList: false,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          isUpdatingTasksList: false,
        }));
      });
  };

  handleProjectChange = (event) => {
    const taskParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      projectId: event.target.value,
    };
    if (taskParams.projectId === 'all') {
      delete taskParams.projectId;
    }
    this.getTaskData(taskParams);
  };

  handleGenerateData = (formdata) => {
    this.setState((state) => ({
      ...state,
      isFetchingActivityData: true,
    }));
    const { startDate, endDate } = this.state;

    const params = {
      teamOwnerId: formdata.teamOwnerId,
      fromDate: startDate.concat(' 00:00:00'),
      toDate: endDate.concat(' 23:59:59'),
      activityPercentageRange: formdata.activity,
      projectId: formdata.project,
      taskId: formdata.task,
      workSessionType: formdata.workSessionType,
    };
    const locationData = new URLSearchParams(window.location.search);
    const teamMemberId = locationData.get('teamMember');
    if (teamMemberId) {
      params.teamMemberId = teamMemberId;
    }
    if (formdata.activity === 'all') {
      delete params.activityPercentageRange;
    }
    if (formdata.project === 'all') {
      delete params.projectId;
    }
    if (formdata.task === 'all') {
      delete params.taskId;
    }
    if (formdata.workSessionType === 'all') {
      delete params.workSessionType;
    }

    activityService
      .get_team_activity_data(params)
      .then((response) => {
        if (response.data.length > 0) {
          const activityData = response.data;
          this.setState((state) => ({
            ...state,
            isFetchingActivityData: false,
            activityList: activityData,
          }));
        } else {
          this.setState((state) => ({
            ...state,
            isFetchingActivityData: false,
            activityList: [],
          }));
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isFetchingActivityData: false,
        }));
        toast.error(API_FAILURE_ERROR);
      });
  };

  render() {
    const {
      projectsList,
      tasksList,
      startDate,
      endDate,
      isFetchingActivityData,
      isLoading,
      activityList,
      isUpdatingProjectsList,
      isUpdatingTasksList,
    } = this.state;
    const {
      history,
      location: { state: fromState },
    } = this.props;
    // Team owner ID
    const teamOwnerId = localStorage.getItem('teamOwnerId');
    const timeZone = getUserData('timeZoneFormatted');
    const { isMobileTracking } = getUserData('defaultTeam');
    // Top header bredCrumb links
    const bredCrumbLinks =
      fromState && fromState.bredCrumbs ? fromState.bredCrumbs : [];
    return (
      <Layout pageHeading={this.pageHeading} bredCrumbLinks={bredCrumbLinks}>
        {isLoading && <Loading contentAreaOnly />}
        <Card>
          <Card.Header>
            <Tab.Container id="TimeSheetPreview" defaultActiveKey="date-range">
              <Row className="align-items-center my-3">
                <Col xs="auto">
                  <div className="card-title h4 m-0">View by</div>
                </Col>
                <Col>
                  <Nav variant="pills">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="day"
                        className="py-1 px-3"
                        onClick={() => history.push('/activity/team/day')}
                      >
                        Day
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="date-range" className="py-1 px-3">
                        Date range
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col xs="auto" className="ml-auto">
                  {timeZone}
                </Col>
              </Row>
            </Tab.Container>
          </Card.Header>
          <Card.Body>
            <Formik
              initialValues={{
                teamOwnerId,
                fromDate: startDate,
                toDate: endDate,
                activity: 'all',
                project: 'all',
                task: 'all',
                workSessionType: 'all',
              }}
              onSubmit={(values) => {
                this.handleGenerateData(values);
              }}
            >
              {(formikprops) => (
                <Form onSubmit={formikprops.handleSubmit}>
                  <Row>
                    <Col md={6} lg={3}>
                      <ProjectListDropdown
                        projectsList={projectsList}
                        isUpdatingProjectsList={isUpdatingProjectsList}
                        handleChange={formikprops.handleChange}
                        handleProjectChange={this.handleProjectChange}
                        isDependedField
                      />
                    </Col>
                    <Col md={6} lg={3}>
                      <Form.Group controlId="task">
                        <Form.Label>Task</Form.Label>
                        <Field
                          className="form-select"
                          as="select"
                          name="task"
                          disabled={
                            isUpdatingTasksList || !tasksList.length > 0
                          }
                        >
                          <option value="all">All</option>
                          {tasksList &&
                            tasksList.length > 0 &&
                            tasksList.map((item, index) => (
                              <option
                                key={`${index}-${item._id}`}
                                value={item._id}
                              >
                                {item.task}
                              </option>
                            ))}
                        </Field>
                      </Form.Group>
                    </Col>
                    <Col md={6} lg={3}>
                      <DateRangePickerField
                        handleDateSelect={this.handleDateSelect}
                        startFrom="last 7 days"
                        showRangeOptions
                        preDefinedRanges={DATE_RANGE_OPTIONS}
                      />
                    </Col>
                    <Col md={6} lg={3}>
                      <PercentageRangeListDropdown />
                    </Col>

                    {isMobileTracking && (
                      <Col md={6} lg={3}>
                        <WorkSessionTypeDropdown />
                      </Col>
                    )}
                    <Col md={6} lg={3}>
                      <Form.Group>
                        <Form.Label>&nbsp;</Form.Label>
                        <div>
                          <Button
                            variant="primary"
                            type="Submit"
                            disabled={isUpdatingProjectsList}
                          >
                            Generate
                          </Button>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card.Body>
          {isFetchingActivityData && <Loading contentAreaOnly />}
          {activityList && <TeamActivityList activityList={activityList} />}
        </Card>
      </Layout>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({
  getOnlineMembers: fetchOnlineMembers,
});

TeamDateRangeActivity.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  getOnlineMembers: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps()
)(TeamDateRangeActivity);
